// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/workflow_case_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { WorkflowCaseService } from "./workflow_case_service_pb";

/**
 * @generated from rpc bffuser.v1.WorkflowCaseService.ListWorkflowCaseRetainedArtifacts
 */
export const listWorkflowCaseRetainedArtifacts = WorkflowCaseService.method.listWorkflowCaseRetainedArtifacts;

/**
 * ListWorkflowCases returns workflow cases for the authenticated
 * organization, with optional filters.
 *
 * @generated from rpc bffuser.v1.WorkflowCaseService.ListWorkflowCases
 */
export const listWorkflowCases = WorkflowCaseService.method.listWorkflowCases;

/**
 * GetWorkflowCase returns the full detail of a single workflow case
 * identified by id.
 *
 * @generated from rpc bffuser.v1.WorkflowCaseService.GetWorkflowCase
 */
export const getWorkflowCase = WorkflowCaseService.method.getWorkflowCase;

/**
 * CreateWorkflowCases creates workflow cases atomically from a single
 * workflow template, using one of two mutually exclusive creation axes
 * (issue #5219): bg_targets creates one case per (bg_code, target_date)
 * combination (N = bg_codes × target_dates) for a template that requires a
 * BG code; no_bg_target creates one case per target_date (N = target_dates)
 * for a template that does not. area is not a creation axis — it is a
 * display attribute derived from the case's own bg_code (Some for a
 * bg_targets case, UNSPECIFIED for a no_bg_target case). If any combination
 * conflicts with an existing open case (same section + bg_code +
 * target_date on the BG axis, or same section + target_date on the no-BG
 * axis), all cases are rejected and the conflicting combinations are
 * returned as WorkflowCaseConflict error details (AC-003a/b).
 *
 * @generated from rpc bffuser.v1.WorkflowCaseService.CreateWorkflowCases
 */
export const createWorkflowCases = WorkflowCaseService.method.createWorkflowCases;

/**
 * UpdateWorkflowCase updates the mutable attributes of a workflow case
 * (target_date). name / note / area_codes were removed in spec #1515/B1/B2.
 * Uses optimistic locking via expected_updated_at.
 *
 * @generated from rpc bffuser.v1.WorkflowCaseService.UpdateWorkflowCase
 */
export const updateWorkflowCase = WorkflowCaseService.method.updateWorkflowCase;

/**
 * DeleteWorkflowCase irreversibly (logically) deletes a NOT_STARTED or
 * IN_PROGRESS workflow case (spec AC-003f/g). deleted_by is injected by
 * the BFF handler from the eauth session (the frontend does not send it).
 * Rejects with FailedPrecondition when the case is COMPLETE or already
 * DELETED. Uses optimistic locking via expected_updated_at
 * (workflow-delete-transition design).
 *
 * @generated from rpc bffuser.v1.WorkflowCaseService.DeleteWorkflowCase
 */
export const deleteWorkflowCase = WorkflowCaseService.method.deleteWorkflowCase;

/**
 * ToggleSubStep completes a specific SubStepInstance. is_completed=false is
 * rejected with FailedPrecondition; undo a completion with UndoSubStepCompletion
 * (AC-WFW-005d/e/f, AC-WFW-037/038). No optimistic lock is applied
 * (false-alarm avoidance); the backend rejects requests on cases that are
 * already explicitly completed OR deleted (spec AC-07).
 *
 * @generated from rpc bffuser.v1.WorkflowCaseService.ToggleSubStep
 */
export const toggleSubStep = WorkflowCaseService.method.toggleSubStep;

/**
 * UndoSubStepCompletion undoes the completion of the latest completed
 * sub-step. Rejected with FailedPrecondition when the target sub-step is not
 * complete, any later sub-step is complete or awaiting approval, or the
 * parent workflow case is already complete (spec AC-WFW-005d/e/f,
 * AC-WFW-008, AC-WFW-037/038). A completed plan-submission sub-step (linked
 * page: demand procurement / generation sales / demand suppression / split
 * supply plan) is always rejected with FailedPrecondition, even when a later
 * sub-step is complete (AC-WFW-005e (d), AC-WFW-038).
 *
 * @generated from rpc bffuser.v1.WorkflowCaseService.UndoSubStepCompletion
 */
export const undoSubStepCompletion = WorkflowCaseService.method.undoSubStepCompletion;

/**
 * ApproveSubStepStage records the authenticated member's approval for a
 * specific approval stage of a sub-step. approver_member_id is NOT sent by
 * the frontend; the BFF handler injects it from the eauth session. Rejected
 * when the case is deleted (spec AC-07).
 *
 * @generated from rpc bffuser.v1.WorkflowCaseService.ApproveSubStepStage
 */
export const approveSubStepStage = WorkflowCaseService.method.approveSubStepStage;

/**
 * ApproveSubStepWithoutStages explicitly approves a required gate with no
 * configured approval stages. The BFF injects the authenticated member.
 *
 * @generated from rpc bffuser.v1.WorkflowCaseService.ApproveSubStepWithoutStages
 */
export const approveSubStepWithoutStages = WorkflowCaseService.method.approveSubStepWithoutStages;

/**
 * CancelSubStepApproval cancels all pending approvals for the specified
 * sub-step, returning it to its pre-approval state. Rejected when the case
 * is deleted (spec AC-07).
 *
 * @generated from rpc bffuser.v1.WorkflowCaseService.CancelSubStepApproval
 */
export const cancelSubStepApproval = WorkflowCaseService.method.cancelSubStepApproval;

/**
 * UpdateSubStepMemo sets or clears the memo of a single SubStepInstance
 * (spec AC-005b, workflow-substep-memo design). memo_by is NOT sent by
 * the frontend; the BFF handler injects it from the eauth session.
 *
 * @generated from rpc bffuser.v1.WorkflowCaseService.UpdateSubStepMemo
 */
export const updateSubStepMemo = WorkflowCaseService.method.updateSubStepMemo;

/**
 * UpdateSubStepApprovalNote edits or clears the note of an already-
 * recorded approval (spec AC-WFW-007a/d). approver_member_id identifies
 * the original approval record; note_by is injected by the BFF handler.
 *
 * @generated from rpc bffuser.v1.WorkflowCaseService.UpdateSubStepApprovalNote
 */
export const updateSubStepApprovalNote = WorkflowCaseService.method.updateSubStepApprovalNote;

/**
 * @generated from rpc bffuser.v1.WorkflowCaseService.UpdateSubStepApprovalWithoutStagesNote
 */
export const updateSubStepApprovalWithoutStagesNote = WorkflowCaseService.method.updateSubStepApprovalWithoutStagesNote;

/**
 * UpdatePreviousApprovalNote edits a preserved "前回承認時の申し送り"
 * record (Decision #3, spec L822/L830: P0 allows any user to edit).
 * Identity is the compound (big_step_display_order, sub_step_display_order,
 * stage_order, approver_member_id, cancelled_at). updated_by is injected
 * by the BFF handler from the eauth session.
 *
 * @generated from rpc bffuser.v1.WorkflowCaseService.UpdatePreviousApprovalNote
 */
export const updatePreviousApprovalNote = WorkflowCaseService.method.updatePreviousApprovalNote;

/**
 * @generated from rpc bffuser.v1.WorkflowCaseService.UpdatePreviousApprovalWithoutStagesNote
 */
export const updatePreviousApprovalWithoutStagesNote = WorkflowCaseService.method.updatePreviousApprovalWithoutStagesNote;

/**
 * DeletePreviousApprovalNote removes a preserved "前回承認時の申し送り"
 * record entirely (Decision #3). Identity mirrors
 * UpdatePreviousApprovalNoteRequest. updated_by is injected by the BFF
 * handler from the eauth session.
 *
 * @generated from rpc bffuser.v1.WorkflowCaseService.DeletePreviousApprovalNote
 */
export const deletePreviousApprovalNote = WorkflowCaseService.method.deletePreviousApprovalNote;

/**
 * ListWorkflowTagPool returns the authenticated organization's derived tag
 * pool (spec AC-TAG-005), used by the 3 tag-input screens for suggestion
 * (AC-TAG-008) and by the frontend's pre-check against the 20-tag pool cap
 * (AC-TAG-006).
 *
 * @generated from rpc bffuser.v1.WorkflowCaseService.ListWorkflowTagPool
 */
export const listWorkflowTagPool = WorkflowCaseService.method.listWorkflowTagPool;

/**
 * ListWorkflowGenerationTargetCandidates returns the 発電の計画提出者コード the
 * creation dialog offers as BG code candidates when the selected template has
 * allows_generation_target_code (spec AC-WFW-003j). Mirrors
 * internalapi.v1.WorkflowCaseService.ListWorkflowGenerationTargetCandidates.
 *
 * @generated from rpc bffuser.v1.WorkflowCaseService.ListWorkflowGenerationTargetCandidates
 */
export const listWorkflowGenerationTargetCandidates = WorkflowCaseService.method.listWorkflowGenerationTargetCandidates;
